export { TruncatedTypography } from './TruncatedTypography';
